'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
export const Route = createFileRoute('/_staff/settings/notification-and-response/_layout/notification-channels/')({
  component: NotificationChannels
});
function NotificationChannels() {
  // 通知チャネルは未実装（空）
  return <VStack className="px-12 py-6" />;
}